/* =========================================================
   CHAGUAL PLP — Galería de fotos en la card (ADITIVO)
   Activa la capa de galería que el server renderiza OCULTA dentro de
   snippets/chagual-product-card.liquid (markup [data-ch-plp-gallery]).

   Contrato:
   - En reposo NO toca nada: la card se ve idéntica. Solo al activar marca
     .is-ready y deja que CSS revele la capa en hover (desktop) / swipe (móvil).
   - Móvil: el track usa scroll-snap nativo; el JS solo sincroniza los puntitos.
   - Desktop: el JS desplaza las slides dentro del viewport fijo y maneja
     flechas + puntos.
   - Se RE-INICIALIZA con el evento propio del catálogo, eventos Shopify/Boost
     y mediante MutationObserver.
   - No duplica listeners: cada card se marca con data-ch-plp-gallery-init.

   Bridge, no owner: solo enriquece por JS las cards que ya traen el markup.
   No fabrica cards ni hace requests por producto.
   ========================================================= */
(function () {
  'use strict';

  var INIT_FLAG = 'chPlpGalleryInit';
  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isTouch =
    window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches;

  function clamp(n, min, max) {
    return n < min ? min : n > max ? max : n;
  }

  function buildDots(gallery, slideCount) {
    var dotsWrap = gallery.querySelector('[data-ch-plp-gallery-dots]');
    if (!dotsWrap || slideCount < 2) return [];
    dotsWrap.removeAttribute('aria-hidden');
    dotsWrap.setAttribute('role', 'group');
    dotsWrap.setAttribute('aria-label', 'Elegir foto');
    var dots = [];
    for (var i = 0; i < slideCount; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'ch-plp-gallery__dot';
      dot.setAttribute('data-ch-plp-gallery-dot', String(i));
      dot.setAttribute('aria-label', 'Foto ' + (i + 1) + ' de ' + slideCount);
      dotsWrap.appendChild(dot);
      dots.push(dot);
    }
    return dots;
  }

  function setActiveDot(dots, index) {
    for (var i = 0; i < dots.length; i++) {
      var active = i === index;
      dots[i].classList.toggle('is-active', active);
      if (active) {
        dots[i].setAttribute('aria-current', 'true');
      } else {
        dots[i].removeAttribute('aria-current');
      }
    }
  }

  function initGallery(gallery) {
    if (!gallery || gallery.nodeType !== 1) return;
    if (gallery.dataset[INIT_FLAG] === '1') return;

    var track = gallery.querySelector('[data-ch-plp-gallery-track]');
    if (!track) return;
    var slides = track.querySelectorAll('[data-ch-plp-gallery-slide]');
    if (!slides.length || slides.length < 2) {
      // Una sola foto: no hay galería que activar.
      gallery.dataset[INIT_FLAG] = '1';
      return;
    }

    gallery.dataset[INIT_FLAG] = '1';

    var prevBtn = gallery.querySelector('[data-ch-plp-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-ch-plp-gallery-next]');
    var status = gallery.querySelector('[data-ch-plp-gallery-status]');
    var dots = buildDots(gallery, slides.length);
    var current = 0;

    var card = gallery.closest('[data-product-title]');
    var productTitle = card ? card.getAttribute('data-product-title') : '';
    var announceTimer = null;
    gallery.removeAttribute('aria-hidden');
    gallery.setAttribute('role', 'group');
    gallery.setAttribute('aria-label', productTitle ? 'Fotos de ' + productTitle : 'Fotos del producto');
    if (prevBtn) prevBtn.removeAttribute('tabindex');
    if (nextBtn) nextBtn.removeAttribute('tabindex');

    function announce(index, deferred) {
      if (!status) return;
      var message = (productTitle ? productTitle + ', foto ' : 'Foto ') + (index + 1) + ' de ' + slides.length;
      var update = function () {
        announceTimer = null;
        if (status.textContent !== message) status.textContent = message;
      };
      if (!deferred) {
        if (announceTimer && window.clearTimeout) window.clearTimeout(announceTimer);
        update();
        return;
      }
      if (announceTimer && window.clearTimeout) window.clearTimeout(announceTimer);
      announceTimer = window.setTimeout(update, 180);
    }

    function goTo(index, fromUser) {
      current = clamp(index, 0, slides.length - 1);

      var target = slides[current];
      if (target && typeof track.scrollTo === 'function') {
        track.scrollTo({
          left: target.offsetLeft,
          behavior: fromUser && !prefersReducedMotion ? 'smooth' : 'auto'
        });
      }

      setActiveDot(dots, current);
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current === slides.length - 1;
      if (fromUser) announce(current, false);
      else if (status) status.textContent = '';
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(current - 1, true);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(current + 1, true);
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(i, true);
      });
    });

    if (isTouch) {
      // Sincroniza el punto activo según la posición de scroll (swipe).
      var scrollRaf = null;
      track.addEventListener(
        'scroll',
        function () {
          if (scrollRaf) return;
          scrollRaf = window.requestAnimationFrame(function () {
            scrollRaf = null;
            var slideWidth = track.clientWidth || 1;
            var index = Math.round(track.scrollLeft / slideWidth);
            index = clamp(index, 0, slides.length - 1);
            if (index !== current) {
              current = index;
              setActiveDot(dots, current);
              announce(current, true);
            }
          });
        },
        { passive: true }
      );
    } else {
      // Desktop: al salir el mouse, volvemos a la foto 1 para que el reposo
      // muestre exactamente la imagen nativa por defecto.
      var resetHost = gallery.closest('.product_image') || gallery.parentElement;
      if (resetHost) {
        resetHost.addEventListener('mouseleave', function () {
          goTo(0, false);
        });
      }
    }

    goTo(0, false);
    gallery.classList.add('is-ready');
  }

  function initWithin(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var galleries = scope.querySelectorAll('[data-ch-plp-gallery]');
    for (var i = 0; i < galleries.length; i++) {
      initGallery(galleries[i]);
    }
    // Si el root es él mismo una galería (caso MutationObserver puntual).
    if (root && root.matches && root.matches('[data-ch-plp-gallery]')) {
      initGallery(root);
    }
  }

  function boot() {
    initWithin(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('pageshow', boot);
  document.addEventListener('shopify:section:load', function (e) {
    initWithin(e && e.target ? e.target : document);
  });

  // Re-inicialización cuando los filtros propios o Shopify/Boost redibujan.
  [
    'chagual:catalog-updated',
    'boost:filter:updated',
    'boost:search:updated'
  ].forEach(function (evtName) {
    document.addEventListener(evtName, function () {
      window.setTimeout(boot, 40);
      window.setTimeout(boot, 240);
      window.setTimeout(boot, 540);
    });
  });

  // Red de seguridad: observa el grid para enriquecer cards que aparezcan
  // por AJAX (load-more, app de filtros) sin volver a inicializar las viejas.
  function startObserver() {
    var grid =
      document.querySelector('[data-product-list]') ||
      document.querySelector('.product-list--collection') ||
      document.body;
    if (!grid) return;

    var pending = false;
    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (
            (node.matches && node.matches('[data-ch-plp-gallery]')) ||
            (node.querySelector && node.querySelector('[data-ch-plp-gallery]'))
          ) {
            if (!pending) {
              pending = true;
              window.requestAnimationFrame(function () {
                pending = false;
                boot();
              });
            }
            return;
          }
        }
      }
    });

    obs.observe(grid, { childList: true, subtree: true });
  }

  if (document.body) {
    startObserver();
  } else {
    document.addEventListener('DOMContentLoaded', startObserver, { once: true });
  }
})();
